import isInView from './isInView'
import getScrollParent from './getScrollParent'

export default function checkScrollInView(el, doLoadImage) {
  const scrollParents = [ getScrollParent(el), window ]
  el.checkScrollInView = () => {
    if (isInView(el, 200)) {
      doLoadImage.call()
      scrollParents.forEach((scrollParent) => {
        scrollParent.removeEventListener('scroll', el.checkScrollInView)
      })
    }
  }
  scrollParents.forEach((scrollParent) => {
    scrollParent.addEventListener('scroll', el.checkScrollInView)
  })

  setTimeout(el.checkScrollInView, 300)
}